<template>
  <div>
    <el-card class="mt-2">
      <!--基础信息-->
      <div style="font-size: 14px; color: #606266">
        <span>No：{{ formData.visitNo }}</span>
        <el-divider direction="vertical"></el-divider>
        <span>Status：{{ formData.scmVisitStatusName }}</span>
        <el-divider direction="vertical"></el-divider>
        <span
          >Create：{{ formData.createByName }} at
          {{ formData.createTime }}</span
        >
        <el-divider direction="vertical"></el-divider>
        <span
          >Modify：{{ formData.modifyByName }} at
          {{ formData.modifyTime }}</span
        >
      </div>
      <div class="d2-mt">
        <el-form ref="formData" :model="formData" :rules="rules">
          <el-row :gutter="20">
            <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }">
              <el-form-item
                :label="$l('visit_label_scmCode') || '供应商'"
                prop="scmCode"
              >
                <dict-select
                  :placeholder="$l('tips_pleaseSelect') || '请选择...'"
                  :disabled="isNewlock"
                  clearable
                  filterable
                  v-model="formData.scmCode"
                  size="medium"
                  url="/digitalCenter/common/dict/scmInfoDict"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
              <el-form-item
                :label="$l('visit_label_visitDate') || '拜访日期'"
                prop="visitDate"
              >
                <el-date-picker
                  :disabled="isEditlock"
                  v-model="formData.visitDate"
                  type="date"
                  size="medium"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 16 }" :lg="{ span: 16 }">
              <el-form-item
                :label="$l('visit_label_scmPerson') || '厂商人员'"
                prop="scmPerson"
              >
                <el-input
                  :disabled="isEditlock"
                  v-model="formData.scmPerson"
                  :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                  maxlength="50"
                  show-word-limit
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
              <el-form-item
                :label="$l('visit_label_visitOwnerCode') || '负责人'"
                prop="visitOwnerCode"
              >
                <dict-select
                  v-model="formData.visitOwnerCode"
                  url="/digitalCenter/common/dict/baseUser"
                  :placeholder="$l('tips_pleaseSelect') || '请选择...'"
                  :disabled="isEditlock"
                  size="medium"
                  filterable
                  clearable
                  :options="{ label: 'label', value: 'code' }"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 16 }">
              <el-form-item
                :label="$l('visit_label_visitParticipant') || '我方人员'"
              >
                <dict-select
                  v-model="formData.listVisitParticipant"
                  url="/digitalCenter/common/dict/baseUser"
                  :placeholder="$l('tips_pleaseSelect') || '请选择...'"
                  :disabled="isEditlock"
                  size="medium"
                  filterable
                  :multiple="true"
                  clearable
                  :options="{ label: 'label', value: 'code' }"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 20 }" :md="{ span: 24 }" :lg="{ span: 24 }">
              <el-form-item
                :label="$l('visit_label_visitTitle') || '拜访目的'"
                prop="visitTitle"
              >
                <el-input
                  :disabled="isEditlock"
                  v-model="formData.visitTitle"
                  :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                  maxlength="50"
                  show-word-limit
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }">
              <el-form-item
                :label="$l('visit_label_visitDescription') || '拜访情况'"
                prop="visitDescription"
              >
                <el-input
                  :disabled="isEditlock"
                  type="textarea"
                  :autosize="{ minRows: 5, maxRows: 10 }"
                  v-model="formData.visitDescription"
                  maxlength="2000"
                  clearable
                  size="medium"
                  :placeholder="$l('tips_pleaseEnter') || '请输入...'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!--按钮-->
        <div class="d2-mt">
          <el-row>
            <el-col :span="20">
              <el-button
                @click="save"
                v-if="!isEditlock && !isApply"
                size="small"
                type="primary"
              >
                {{ $l('INDEX.btn_save') || '保存' }}
              </el-button>
              <el-button
                @click="apply"
                v-if="isApply"
                size="small"
                type="primary"
              >
                {{ $l('INDEX.btn_applly') || '申请' }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>
    <el-card v-if="formData.visitCode" class="mt-2">
      <images-table
        :scmCode="formData.scmCode"
        :visitCode="formData.visitCode"
      />
    </el-card>
    <el-card v-if="formData.visitCode" class="mt-2">
      <score-table
        :scmCode="formData.scmCode"
        :visitCode="formData.visitCode"
      />
    </el-card>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import { mapActions } from 'vuex'
import ImagesTable from '../images-table'
import ScoreTable from '../score-table'
export default {
  name: 'personal-myScmInfo-myVisit-edit',
  components: { ImagesTable, ScoreTable },
  data() {
    return {
      pageHeader: '',
      dialogVisible: false,
      isNewlock: false,
      isEditlock: false,
      params: {
        type: '',
        visitCode: '',
      },
      formData: {
        visitCode: '',
        visitNo: '',
        scmCode: '',
        visitDate: '',
        visitOwnerCode: '',
        scmPerson: '',
        visitPerson: '',
        visitTitle: '',
        visitDescription: '',
        scmVisitStatus: '',
        scmVisitStatusName: '',
        createTime: '',
        createByName: '',
        modifyTime: '',
        modifyByName: '',
        visitScore: '',
      },
      rules: {
        scmCode: [
          {
            required: true,
            message: this.$l('visit_form_rule_scmCode') || '请选择供应商',
            trigger: 'blur',
          },
        ],
        visitDate: [
          {
            required: true,
            message: this.$l('visit_form_rule_visitDate') || '请选择拜访日期',
            trigger: 'blur',
          },
        ],
        visitOwnerCode: [
          {
            required: true,
            message:
              this.$l('visit_form_rule_visitOwnerCode') || '请选择拜访负责人',
            trigger: 'blur',
          },
        ],
        visitTitle: [
          {
            required: true,
            message: this.$l('visit_form_rule_visitTitle') || '请输入拜访目的',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    isApply() {
      return this.$route.params.pageType === 'apply'
    },
  },
  mounted() {
    let scmCode = this.$route.params.scmCode
    let type = this.$route.params.pageType
    let visitCode = this.$route.params.visitCode
    this.init(type, visitCode, scmCode)
  },
  // activated() {
  //   let scmCode = this.$route.params.scmCode
  //   let type = this.$route.params.pageType
  //   let visitCode = this.$route.params.visitCode
  //   this.init(type, visitCode, scmCode)
  // },
  methods: {
    ...mapActions('admin/page', ['close']),
    init(type, visitCode, scmCode) {
      this.resetData()
      if (type === 'add') {
        this.pageHeader = this.$l('visit_page_add') || '新增拜访记录'
        this.isNewlock = false
        this.isEditlock = false
        this.addLoad(scmCode)
      }
      if (type === 'edit') {
        this.pageHeader = this.$l('visit_page_edit') || '编辑拜访记录'
        this.isNewlock = true
        this.isEditlock = false
        this.params.visitCode = visitCode
        this.detailLoad(visitCode)
      }
      if (type === 'view') {
        this.pageHeader = this.$l('visit_page_view') || '查看拜访记录'
        this.isNewlock = true
        this.isEditlock = true
        this.params.visitCode = visitCode
        this.detailLoad(visitCode)
      }
      if (type === 'apply') {
        this.pageHeader = this.$l('visit_page_apply') || '提交报销申请'
        this.isNewlock = true
        this.isEditlock = false
        this.params.visitCode = visitCode
        this.detailLoad(visitCode)
      }
    },
    addLoad(scmCode) {
      if (scmCode == null || scmCode == 'new' || scmCode == '') {
        this.formData.scmCode = ''
      } else {
        this.formData.scmCode = scmCode
        this.isNewlock = true
      }
    },
    detailLoad(val) {
      let param = { visitCode: val }
      this.$api.scmInfoVisitDetailApi(param).then((res) => {
        this.formData = res.body
      })
    },
    // 保存数据
    save() {
      this.saveData()
    },
    apply() {
      this.saveData()
    },
    saveData() {
      const form = this.$refs.formData
      validate.formValidate([form], (valid) => {
        if (valid) {
          this.$api.scmInfoVisitSaveApi(this.formData).then((res) => {
            if (this.isApply) {
              this.applyVisit(res.body)
            } else {
              this.formData.visitCode = res.body
              this.saveOkQuestion()
            }
          })
        }
      })
    },
    applyVisit(val) {
      this.$api
        .scmInfoVisitApplyApi({
          visitCode: val,
          linkUrl: this.$joinURL(`/opview/visit/${val}`, {
            joinOrigin: true,
            joinBasePath: false,
          }),
        })
        .then(() => {
          this.saveOkQuestion('Apply')
        })
    },
    saveOkQuestion(saveType) {
      let msg = this.$l('tips_save_ok') || '保存成功!'
      if (saveType === 'Apply') {
        msg = this.$l('tips_apply_ok') || '申请成功!'
      }
      this.$alert(msg, this.$l('INDEX.tips_question_title') || '提示信息', {
        confirmButtonText: '确定',
        callback: () => {
          // this.closeCurPage()
        },
      })
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },

    // 重置表单数据
    resetData() {
      this.formData = {
        visitCode: '',
        visitNo: '',
        scmCode: '',
        visitDate: '',
        visitOwnerCode: '',
        scmPerson: '',
        visitPerson: '',
        visitTitle: '',
        visitDescription: '',
        scmVisitStatus: '',
        scmVisitStatusName: '',
        createTime: '',
        createByName: '',
        modifyTime: '',
        modifyByName: '',
        visitScore: '',
      }
      this.$refs.formData.resetFields()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.text-annotation {
  color: $color-primary;
  font-size: 13px;
}
.avatar-uploader {
  i {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: #409eff;
    }
  }
}
.icon-right {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
}
.events-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px !important;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
}
.events-uploader-icon-small {
  font-size: 28px;
  color: #8c939d;
  width: 120px !important;
  height: 80px;
  line-height: 80px !important;
  text-align: center;
}
.events {
  width: 300px !important;
  height: 200px;
  display: block;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
